// global imports
import { Grid, InputLabel, makeStyles, TextField, Theme } from '@material-ui/core';
import { StyleRules } from '@material-ui/core/styles';
import _ from 'lodash';
import React, { useRef, useState } from 'react';
import { withLocalize } from 'react-localize-redux';

// project imports
import commonStyles from '../../../../assets/jss/commonStyles';

// project types imports
import { IStyleProps, PropsClasses } from '../../../../types/StyleProps';

// local imports
import { Props } from './types';

const useStyles = makeStyles<Theme, IStyleProps>(commonStyles as StyleRules);

const ShopName = (props: Props) => {
  const classes: PropsClasses = useStyles({} as IStyleProps);

  const { translate, name, onChange } = props;

  const [currentValue, setCurrentValue] = useState(name);
  const delayedInput = useRef(_.debounce(value => onChange('name', value), 1000)).current;

  const handleValueChange = (ev: React.ChangeEvent<{ value: string }>) => {
    const value = ev.target.value;

    setCurrentValue(value);
    delayedInput(value);
  };

  return (
    <Grid container={true}>
      <Grid item={true} xs={4}>
        <InputLabel className={classes.pt10}>{translate('prestashop.shop-name')}</InputLabel>
      </Grid>
      <Grid item={true} xs={8}>
        <TextField value={currentValue} className={classes.w100} onChange={handleValueChange} />
      </Grid>
    </Grid>
  );
};

export default withLocalize(ShopName);
